/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 绩效列表 的 **请求配置**
 *
 * @分类 买手API
 * @请求头 `POST /erp/Bonus/getList`
 */
const postGetListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/Bonus/getList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 绩效列表 的 **请求函数**
 *
 * @分类 买手API
 * @请求头 `POST /erp/Bonus/getList`
 */
export const postGetList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetListRequestConfig, requestData), ...args);
};
postGetList.requestConfig = postGetListRequestConfig;
/**
 * 接口 获取单条绩效的明细 的 **请求配置**
 *
 * @分类 买手API
 * @请求头 `POST /erp/Bonus/getDetail`
 */
const postGetDetailRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/Bonus/getDetail",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetDetail",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取单条绩效的明细 的 **请求函数**
 *
 * @分类 买手API
 * @请求头 `POST /erp/Bonus/getDetail`
 */
export const postGetDetail = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetDetailRequestConfig, requestData), ...args);
};
postGetDetail.requestConfig = postGetDetailRequestConfig;
/**
 * 接口 绩效列表导出 的 **请求配置**
 *
 * @分类 买手API
 * @请求头 `POST /erp/Bonus/exportList`
 */
const postExportListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/Bonus/exportList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 绩效列表导出 的 **请求函数**
 *
 * @分类 买手API
 * @请求头 `POST /erp/Bonus/exportList`
 */
export const postExportList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postExportListRequestConfig, requestData), ...args);
};
postExportList.requestConfig = postExportListRequestConfig;
/**
 * 接口 绩效列表-详情导出 的 **请求配置**
 *
 * @分类 买手API
 * @请求头 `POST /erp/Bonus/exportDetail`
 */
const postExportDetailRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/Bonus/exportDetail",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportDetail",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 绩效列表-详情导出 的 **请求函数**
 *
 * @分类 买手API
 * @请求头 `POST /erp/Bonus/exportDetail`
 */
export const postExportDetail = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postExportDetailRequestConfig, requestData), ...args);
};
postExportDetail.requestConfig = postExportDetailRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/bonus.js